import { render, staticRenderFns } from "./dyuserInfo.vue?vue&type=template&id=04494101&scoped=true&"
import script from "./dyuserInfo.vue?vue&type=script&lang=js&"
export * from "./dyuserInfo.vue?vue&type=script&lang=js&"
import style0 from "./dyuserInfo.vue?vue&type=style&index=0&id=04494101&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04494101",
  null
  
)

export default component.exports